import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=e7831b2e&"
import script from "./app-footer.vue?vue&type=script&setup=true&lang=js&"
export * from "./app-footer.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=e7831b2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports